exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.display {\n  color: black;\n}\n\ndiv.display.full {\n  margin: 1ex;\n  padding: 1ex;\n  border: thin solid silver;\n  border-radius: 8px;\n}\n\ndiv.display.short {\n  border: thin solid silver;\n  border-radius: 8px;\n  display: inline-block;\n  padding: 0.3ex 1ex;\n  margin-top: 10px;\n  margin-left: 1ex;\n}\n\ndiv.display.full button {\n  display: block;\n  float: right;\n}\n\n.error {\n  outline: 2px solid red;\n}\n\nbutton.delete {\n  color:red;\n}\n\nbutton.delete.confirm {\n  margin: 10px;\n  outline: 2px solid red;\n}\n\nbutton.editButton {\n  float: right;\n\n}\n\ndiv.buttonRow {\n  text-align: center;\n  margin:10px 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/topic-box/topic-box.component.css
// module id = 408
// module chunks = 0